import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const navHeight = document.querySelector('.navbar').offsetHeight;
      const offsetTop = contactSection.offsetTop - navHeight - 20;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  };

  return (
    <section className="hero"> 
      <div className="hero-container">
        <div className="hero-blob">
          <div className="hero-bubble-visual" aria-hidden="true">
            <div className="blob-colour-fill"></div>
            <div className="blob-glass"></div>
            <div className="blob-rim"></div>
          </div>

          {/* Keep the copy stationary while the bubble and its colour rotate. */}
          <div className="hero-content">
            <h1 className="hero-title">
              Delivering meaningful outcomes
              <br />
              through intelligent AI solutions.
            </h1>
            <p className="hero-subtitle">
              Data & AI consultancy combining deep domain expertise with
              practical, commercially focused implementation.
            </p>
            <div className="hero-cta-wrapper">
              <span className="hero-cta-text">LET'S TALK</span>
              <button className="hero-cta" onClick={scrollToContact}>→</button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
